var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c(_vm.reCaptchaComponentVersion,_vm._g({tag:"Component",attrs:{"callback":_vm.callback,"index":_vm.index}},_vm.$listeners))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }